import React from 'react';

export const ContainerTitleTable = ({children}) => {
    return (
        <div className="rounded-t bg-white mb-0 px-6 py-6 mt-1">
            <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">{children}</h6>
            </div>
        </div>
    );
};

